import { BaseStoreData } from '../types/storeType'

export const oliverStoreInfo: BaseStoreData = {
  contactUrl: '',
}
